import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

/** The MCP Servers pill on Admin Settings; the Knockout page mounts the scene, so there is no Component here. */
export const mcpConnectionsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("mcp-connections-nro-heading", "MCP Servers"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("mcp-connections-nro-description", "MCP servers BrazeAI Operator can use tools from"),
  pageNameForTracking: () => "MCP Servers",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) =>
    featureOn("sage_ai_agentic_mcp_connections") && hasPermission("company", { permission: "admin" }),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
